import React, { useMemo } from 'react'
import { RADOM_COLORS } from '../../../util/Constants'
import { ExternalAccount } from '../../../state/Radom'
import { getMethod } from '../../../util/Managed'
import { networkName } from '../../../util/AssetLabels'
import USDLogo from '../../../images/USDLogo.svg'
import EUROLogo from '../../../images/EUROLogo.svg'

interface Props {
  account: ExternalAccount
}

const ExternalAccountSelectorTag = ({ account }: Props): JSX.Element => {
  const isCrypto = account.accountType === 'crypto'

  const logo = useMemo(() => {
    if (isCrypto && account.crypto) {
      return getMethod(account.crypto.network).logo
    }
    switch (account.accountType) {
    case 'us': return USDLogo
    case 'iban': return EUROLogo
    default: return ''
    }
  }, [account])

  const detailText = useMemo(() => {
    if (isCrypto && account.crypto) {
      const addr = account.crypto.address
      return addr.length > 12 ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : addr
    }
    if (account.account) {
      return `••••${account.account.last4}`
    }
    if (account.iban) {
      return `••••${account.iban.last4}`
    }
    return ''
  }, [account])

  const label = useMemo(() => {
    if (isCrypto && account.crypto) {
      return networkName(account.crypto.network)
    }
    return account.bankName || account.accountOwnerName
  }, [account])

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minHeight: 42, padding: '2px 6px' }}>
      {logo && <div style={{
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundImage: `url(${logo})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}/>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 500, fontSize: 13.5, color: 'var(--ink, #20242d)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
          {detailText && (
            <span style={{ fontSize: 11.5, color: 'var(--icon-muted, #747894)', fontFamily: isCrypto ? 'var(--font-mono)' : 'inherit' }}>{detailText}</span>
          )}
        </div>
        <span style={{ fontSize: 11.5, fontWeight: 400, color: RADOM_COLORS.GRAY_DARKER, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {account.accountOwnerName} · {account.currency.toUpperCase()}
        </span>
      </div>
    </div>
  )
}

export default ExternalAccountSelectorTag
